import React, { ReactNode } from 'react';
import Sidebar from '../components/SideBar';

interface JeuneInnovateurLayoutProps {
  children: ReactNode; // Explicitly define children as a prop
}
interface JeuneInnovateurLayoutContainerProps {
  passedChildren: ReactNode; // Explicitly define children as a prop
}

const JeuneInnovateurLayout: React.FC<JeuneInnovateurLayoutProps> = ({ children }) => {
  return <JeuneInnovateurLayoutContainer passedChildren={children} />;
};

const JeuneInnovateurLayoutContainer: React.FC<JeuneInnovateurLayoutContainerProps> = ({ passedChildren }) => {
  return (
    <div className="flex flex-row w-full">
      <Sidebar />
      <main className='flex-1'>
        {passedChildren}
      </main>
    </div>
  );
};

export default JeuneInnovateurLayout;
